<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="d-grid gap-2">
          <router-link :to="'log-text'" class="btn btn-info py-4 px-3 text-start">
            <span class="h2">✍️ Write log entry</span>
            <br>
            <small><i>For end of shift, general log of Alnasir's status</i></small>
          </router-link>
          <router-link :to="'log'" class="btn btn-secondary py-4 px-3 text-start">
            <span class="h2">📄 View care log</span>
          </router-link>
          <hr>
          <router-link :to="'log-urination'" class="btn btn-warning py-4 px-3 text-start">
            <span class="h2">🚽 Record urine output</span>
          </router-link>
          <router-link :to="'log-bm'" class="btn btn-outline-primary py-4 px-3 text-start">
            <span class="h2">💩 Record BM</span><br>
            <span><i>{{ lastBowelMovementRelativeText }}</i></span>
          </router-link>
          <small class="text-muted" v-if="lastBowelMovementAt">
            <i>{{ lastBowelMovementFullText }}</i>
          </small>
          <router-link :to="'contacts'" class="btn btn-outline-secondary py-4 px-3 text-start">
            <span class="h2">📞 Family contact info</span>
          </router-link>
          <router-link :to="'reports'" class="btn btn-outline-info py-4 px-3 text-start">
            <span class="h2">📊 Generate Reports</span>
            <br>
            <small><i>Filter care logs by date range and keywords</i></small>
          </router-link>
          <router-link :to="'inventory'" class="btn btn-outline-dark py-4 px-3 text-start">
            <span class="h2">📦 Inventory</span>
            <br>
            <small><i>Track supplies and log count changes</i></small>
          </router-link>
          <PushAlerts />
          <router-link
            v-if="superuser"
            :to="'notification-settings'"
            class="btn btn-outline-secondary py-4 px-3 text-start"
          >
            <span class="h2">🔔 Notification settings</span>
            <br>
            <small><i>Choose who gets inventory alerts</i></small>
          </router-link>
          <hr>
          <h3><i>Coming soon:</i></h3>
          <router-link :to="'log-bp'" class="disabled btn btn-outline-danger py-4 px-3 text-start">
            <span class="h2">❤️ Record BP</span>
          </router-link>
          <router-link :to="'log-exercise'" class="disabled btn btn-outline-secondary py-4 px-3 text-start">
            <span class="h2">🏋️ Record exercise</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PushAlerts from './PushAlerts.vue';

export default {
  name: 'Home',
  components: {
    PushAlerts,
  },
  data: () => ({
    lastBowelMovementAt: null,
    superuser: false,
  }),
  async mounted() {
    const [{ data: me }, { data: lastBowelMovementResponse }] = await Promise.all([
      this.$api.get('/me'),
      this.$api.get('/care-logs/last-bowel-movement'),
    ]);

    this.lastBowelMovementAt = lastBowelMovementResponse?.data?.createdAt || null;
    this.superuser = me.superuser === true;
  },
  computed: {
    lastBowelMovementRelativeText() {
      if (!this.lastBowelMovementAt) return '';

      const date = new Date(this.lastBowelMovementAt);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const absMs = Math.abs(diffMs);

      const minuteMs = 60 * 1000;
      const hourMs = 60 * minuteMs;
      const dayMs = 24 * hourMs;

      if (absMs < minuteMs) return 'Last BM: just now';
      if (absMs < hourMs) {
        const minutes = Math.floor(absMs / minuteMs);
        return `Last BM: ${minutes} minute${minutes === 1 ? '' : 's'} ago`;
      }
      if (absMs < dayMs) {
        const hours = Math.floor(absMs / hourMs);
        return `Last BM: ${hours} hour${hours === 1 ? '' : 's'} ago`;
      }

      const days = Math.floor(absMs / dayMs);
      return `Last BM: ${days} day${days === 1 ? '' : 's'} ago`;
    },
    lastBowelMovementFullText() {
      if (!this.lastBowelMovementAt) return '';
      const date = new Date(this.lastBowelMovementAt);
      return `At: ${date.toLocaleString()}`;
    },
  },
}
</script>

<style scoped>
</style>